var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGamerGuy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 641.32 630.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:url(#radial-gradient);}.cls-3{fill:url(#radial-gradient-2);}.cls-4{isolation:isolate;}.cls-5{fill:url(#radial-gradient-3);}.cls-6{fill:url(#radial-gradient-4);}.cls-7{fill:url(#radial-gradient-5);}.cls-8{fill:url(#linear-gradient);}.cls-9{fill:url(#linear-gradient-2);}.cls-10{fill:url(#linear-gradient-3);}.cls-11{fill:url(#linear-gradient-4);}.cls-12{fill:url(#linear-gradient-5);}.cls-13{fill:url(#radial-gradient-6);}.cls-14{fill:url(#linear-gradient-6);}.cls-15{fill:#fff;}.cls-16{fill:url(#radial-gradient-8);}.cls-17{fill:url(#radial-gradient-9);}.cls-18{fill:url(#linear-gradient-7);}.cls-19{fill:#c83e96;}.cls-20{fill:url(#radial-gradient-10);}.cls-21{fill:url(#radial-gradient-11);}.cls-22{fill:#0f1132;}.cls-23{fill:url(#radial-gradient-12);}.cls-24{fill:url(#radial-gradient-13);}.cls-25{fill:url(#radial-gradient-14);}.cls-26{fill:url(#linear-gradient-8);}.cls-27{fill:url(#linear-gradient-9);}.cls-28{fill:url(#radial-gradient-15);}.cls-29{fill:url(#radial-gradient-16);}.cls-30{fill:url(#radial-gradient-17);}.cls-31{fill:url(#linear-gradient-10);}.cls-32{fill:url(#radial-gradient-18);}.cls-33{fill:url(#linear-gradient-11);}.cls-34{fill:url(#linear-gradient-12);}.cls-35{fill:url(#radial-gradient-19);}.cls-36{fill:url(#linear-gradient-13);}.cls-37{fill:url(#linear-gradient-14);}.cls-38{fill:url(#radial-gradient-20);}.cls-39{fill:url(#linear-gradient-15);}.cls-40{fill:url(#radial-gradient-21);}.cls-41{fill:url(#radial-gradient-22);}.cls-42{fill:url(#radial-gradient-23);}.cls-43{fill:url(#linear-gradient-16);}.cls-44{fill:url(#radial-gradient-24);}.cls-45{fill:url(#radial-gradient-25);}.cls-46{fill:url(#linear-gradient-17);}.cls-47{fill:url(#radial-gradient-26);}.cls-48{fill:url(#radial-gradient-27);}.cls-49{fill:url(#radial-gradient-28);}.cls-50{fill:url(#linear-gradient-18);}.cls-51{fill:url(#radial-gradient-29);}.cls-52{fill:url(#radial-gradient-30);}.cls-53{fill:url(#radial-gradient-31);}.cls-54{fill:url(#radial-gradient-32);}.cls-55{fill:url(#radial-gradient-33);}.cls-56{fill:url(#radial-gradient-34);}.cls-57{fill:url(#radial-gradient-35);}.cls-58{fill:url(#radial-gradient-36);}.cls-59{fill:url(#radial-gradient-37);}.cls-60{fill:url(#radial-gradient-38);}.cls-61{fill:url(#linear-gradient-19);}.cls-62{fill:url(#radial-gradient-39);}.cls-63{fill:url(#radial-gradient-40);}.cls-64{fill:url(#radial-gradient-41);}.cls-65{fill:url(#radial-gradient-42);}.cls-66{fill:url(#radial-gradient-43);}.cls-67{fill:url(#radial-gradient-44);}.cls-68{fill:url(#radial-gradient-45);}.cls-69{fill:url(#linear-gradient-20);}.cls-70{fill:url(#radial-gradient-46);}.cls-71{fill:url(#linear-gradient-21);}.cls-72{fill:url(#radial-gradient-47);}.cls-73{fill:url(#radial-gradient-48);}.cls-74{fill:url(#radial-gradient-49);}.cls-75{fill:url(#linear-gradient-22);}.cls-76{fill:url(#radial-gradient-50);}.cls-77{fill:url(#linear-gradient-23);}.cls-78{fill:url(#linear-gradient-24);}.cls-79{fill:url(#linear-gradient-25);}.cls-80{fill:url(#linear-gradient-26);}.cls-81{clip-path:url(#clip-path);}.cls-82{opacity:0.32;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 452.28,
    cy: 1704.2,
    r: 624.47,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 2105.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8a3494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#742b8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#532773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#361d5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#1f134d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#150d3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#0f1036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0e1135"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 300.38,
    cy: 2046.76,
    r: 126,
    gradientTransform: "matrix(1.02, 0, 0, -0.77, 4.2, 1877.09)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d799c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#c83e96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#c83e96",
    stopOpacity: 0.67
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#c83e96",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#c83e96",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#c83e96",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c83e96",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 626.23,
    cy: 1733.41,
    r: 193.28,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 2105.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8a3494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#7e2a90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#572876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#150d3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0e1135"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 223.72,
    cy: 1857.6,
    r: 144.55,
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 337.38,
    cy: 1760.96,
    r: 170.31,
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 291.91,
    y1: 1784.37,
    x2: 291.91,
    y2: 1980.78,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 2105.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#31bfc7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8a3494"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 291.91,
    y1: 1789.48,
    x2: 291.91,
    y2: 1917.59,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 340.61,
    y1: 1774.8,
    x2: 283.68,
    y2: 1769.63,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 2105.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#130f3b",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0e1135"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 377.56,
    y1: 1748.46,
    x2: 297.01,
    y2: 1750.36,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 2105.62)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 377.57,
    y1: 1748.97,
    x2: 297.02,
    y2: 1750.88,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 2105.62)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 457.02,
    cy: 1778.64,
    r: 168.11,
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 257.92,
    y1: 1850.23,
    x2: 297.56,
    y2: 1940.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 348.88,
    cy: 1811.76,
    r: 98.12,
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 335.01,
    cy: 1790.1,
    r: 121.35,
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 413.76,
    y1: 1782.18,
    x2: 353.9,
    y2: 1857.63,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 2105.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#56c6d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#f7b3d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#e6539e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8a3494"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: 450.28,
    cy: 1988.71,
    r: 230.01,
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: 622.78,
    cy: 1969.73,
    r: 204.35,
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: 437.53,
    cy: 1880.64,
    r: 23.17,
    gradientTransform: "matrix(1, 0, 0, -1, -0.02, 2105.61)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#c83e96",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#c83e96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c83e96",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-13",
    cx: 437.49,
    cy: 1833.37,
    r: 23.19,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 2105.62)",
    xlinkHref: "#radial-gradient-12"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-14",
    cx: 437.52,
    cy: 1786.09,
    r: 23.16,
    gradientTransform: "matrix(1, 0, 0, -1, -0.09, 2105.62)",
    xlinkHref: "#radial-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 509.94,
    y1: 1814.77,
    x2: 509.94,
    y2: 1958.67,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 509.94,
    y1: 1771.93,
    x2: 509.94,
    y2: 1861.67,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-15",
    cx: 333.24,
    cy: 1813.49,
    r: 128.76,
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-16",
    cx: 331.02,
    cy: 1781.02,
    r: 140.83,
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-17",
    cx: 332.61,
    cy: 1774.66,
    r: 108.44,
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 634.19,
    y1: 1607.87,
    x2: 404.75,
    y2: 1655.59,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 2105.62)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-18",
    cx: 349.65,
    cy: 1682.22,
    r: 199.11,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 2105.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0f1132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0e1135"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 501.12,
    y1: 1550.39,
    x2: 532.17,
    y2: 1518.76,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 2105.62)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 614.65,
    y1: 1514,
    x2: 385.23,
    y2: 1561.72,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 2105.62)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-19",
    cx: 490.68,
    cy: 1528.42,
    r: 7.83,
    xlinkHref: "#radial-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 289.17,
    y1: 1749.96,
    x2: -24.14,
    y2: 1577.06,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 2105.62)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -15.82,
    y1: 1628.1,
    x2: 46.29,
    y2: 1626.95,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 2105.62)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-20",
    cx: 0.2,
    cy: 1603.36,
    r: 132.64,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 2105.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#45aae0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#218ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#026aad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#124a87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#203467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#192151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#111542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#0d1137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0e1135"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 240.62,
    y1: 1617.76,
    x2: 39.07,
    y2: 1514.6,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 2105.62)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-21",
    cx: 13.75,
    cy: 1528.42,
    r: 7.83,
    xlinkHref: "#radial-gradient-18"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-22",
    cx: 198.14,
    cy: 1892.69,
    r: 88.06,
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-23",
    cx: 353.48,
    cy: 1750.28,
    r: 47.95,
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 243.53,
    y1: 1883.27,
    x2: 216.14,
    y2: 1889.96,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-24",
    cx: 245.69,
    cy: 1869.85,
    r: 89.16,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 2105.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8a3494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#7e2a90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#572876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#150d3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#0e1135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70cddd"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-25",
    cx: 267.61,
    cy: 1603.46,
    r: 73.64,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 315.48,
    y1: 1598.2,
    x2: 207.54,
    y2: 1515.1,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 2105.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7b3d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#e6539e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8a3494"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-26",
    cx: 337.58,
    cy: 1777.1,
    r: 70.83,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 2105.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8a3494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#832c91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#6e2b89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#321b5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0e1135"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-27",
    cx: 415.23,
    cy: 1719.9,
    r: 231.17,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-28",
    cx: 462.04,
    cy: 1685.51,
    r: 176.17,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 2105.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d799c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#c867a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#c5479a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#c83e96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#c83e96",
    stopOpacity: 0.67
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#c83e96",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#c83e96",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#c83e96",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c83e96",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 330.43,
    y1: 1551.23,
    x2: 265.47,
    y2: 1507.77,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-29",
    cx: 297.9,
    cy: 1862.78,
    r: 125.36,
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-30",
    cx: 228.49,
    cy: 1728.96,
    r: 298.29,
    xlinkHref: "#radial-gradient-24"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-31",
    cx: 353.37,
    cy: 1869.75,
    r: 299.59,
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-32",
    cx: 152.5,
    cy: 1652.5,
    r: 77.49,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-33",
    cx: 276.73,
    cy: 1653.03,
    r: 282.83,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-34",
    cx: 247.29,
    cy: 1634.89,
    r: 86.85,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-35",
    cx: 221.99,
    cy: 1694.68,
    r: 49.09,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-36",
    cx: 281.8,
    cy: 1655.2,
    r: 91.36,
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-37",
    cx: 305.38,
    cy: 1761,
    r: 78.19,
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-38",
    cx: 158.47,
    cy: 1598.64,
    r: 29.12,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 144.44,
    y1: 1588.04,
    x2: 172.51,
    y2: 1588.04,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 2105.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#319cb1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0e1135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#2c1856"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3d2062"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-39",
    cx: 66.11,
    cy: 1592.37,
    r: 110.05,
    xlinkHref: "#radial-gradient-20"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-40",
    cx: 296.79,
    cy: 1579,
    r: 154.45,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-41",
    cx: 67.54,
    cy: 1557.5,
    r: 67.71,
    xlinkHref: "#radial-gradient-20"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-42",
    cx: 131.54,
    cy: 1545.57,
    r: 47.8,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-43",
    cx: 187.42,
    cy: 1557.03,
    r: 46.8,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-44",
    cx: 156.85,
    cy: 1552.73,
    r: 46.21,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-45",
    cx: 236.62,
    cy: 1551.77,
    r: 45.3,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 293.79,
    y1: 1802.84,
    x2: 240.3,
    y2: 1721.16,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-46",
    cx: 288.98,
    cy: 1828.79,
    r: 120.14,
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 254.34,
    y1: 1814.78,
    x2: 208.02,
    y2: 1808.08,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 2105.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#8bd4e2",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293793",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-47",
    cx: 251.1,
    cy: 1889.28,
    r: 32.82,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 2105.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcccad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#8a3494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#7e2a90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#572876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#150d3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0e1135"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-48",
    cx: 257.63,
    cy: 1880.85,
    r: 74.86,
    xlinkHref: "#radial-gradient-24"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-49",
    cx: 265.43,
    cy: 1877.82,
    r: 56.38,
    xlinkHref: "#radial-gradient-47"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 254.24,
    y1: 1884.77,
    x2: 232.28,
    y2: 1885.72,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 2105.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8bd4e2",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71c595",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-50",
    cx: 281.03,
    cy: 1881.64,
    r: 65.39,
    xlinkHref: "#radial-gradient-47"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 383.72,
    y1: 1767.79,
    x2: 361.62,
    y2: 1767.79,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 2105.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#792a90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#a367ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#8a3494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#833795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#6a499d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#3d89b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#319cb1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 365.04,
    y1: 1791.01,
    x2: 374.82,
    y2: 1794.48,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 387.77,
    y1: 1777.74,
    x2: 360.79,
    y2: 1777.74,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 2105.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d2062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#8a3494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#7e2a90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#572876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#150d3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#0e1135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#319cb1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 387.77,
    y1: 1758.56,
    x2: 360.79,
    y2: 1758.56,
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 200.9,
    y: 19.98,
    width: 197.39,
    height: 144.4
  })), /*#__PURE__*/React.createElement("image", {
    id: "image-2",
    width: 2052,
    height: 342,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAACAgAAAFXCAYAAAAlY+5YAAAACXBIWXMAACXVAAAl1QH32jhSAAAgAElEQVR4Xuzd0ZLrKpIoUHyi//+Tx/fhXMVhsxNIJNmWrbUiFECSIFf1bM9DZlc/ns9nAQAAAAAAAAB+2z+zBAAAAAAAAADg+2kQAAAAAAAAAIAb0CAAAAAAAAAAADegQQAAAAAAAAAAbkCDAAAAAAAAAADcgAYBAAAAAAAAALgBDQIAAAAAAAAAcAMaBAAAAAAAAADgBjQIAAAAAAAAAMANaBAAAAAAAAAAgBvQIAAAAAAAAAAAN6BBAAAAAAAAAABuQIMAAAAAAAAAANyABgEAAAAAAAAAuAENAgAAAAAAAABwAxoEAAAAAAAAAOAGNAgAAAAAAAAAwA1oEAAAAAAAAACAG9AgAAAAAAAAAAA3oEEAAAAAAAAAAG5AgwAAAAAAAAAA3IAGAQAAAAAAAAC4AQ0CAAAAAAAAAHADGgQAAAAAAAAA4AY0CAAAAAAAAADADWgQAAAAAAAAAIAb0CAAAAAAAAAAADegQQAAAAAAAAAAbkCDAAAAAAAAAADcgAYBAAAAAAAAALgBDQIAAAAAAAAAcAMaBAAAAAAAAADgBjQIAAAAAAAAAMANaBAAAAAAAAAAgBvQIAAAAAAAAAAAN6BBAAAAAAAAAABuQIMAAAAAAAAAANyABgEAAAAAAAAAuAENAgAAAAAAAABwAxoEAAAAAAAAAOAGNAgAAAAAAAAAwA1oEAAAAAAAAACAG9AgAAAAAAAAAAA3oEEAAAAAAAAAAG5AgwAAAAAAAAAA3IAGAQAAAAAAAAC4AQ0CAAAAAAAAAHADGgQAAAAAAAAA4AY0CAAAAAAAAADADWgQAAAAAAAAAIAb0CAAAAAAAAAAADegQQAAAAAAAAAAbkCDAAAAAAAAAADcgAYBAAAAAAAAALgBDQIAAAAAAAAAcAMaBAAAAAAAAADgBjQIAAAAAAAAAMANaBAAAAAAAAAAgBvQIAAAAAAAAAAAN6BBAAAAAAAAAABuQIMAAAAAAAAAANyABgEAAAAAAAAAuAENAgAAAAAAAABwAxoEAAAAAAAAAOAGNAgAAAAAAAAAwA1oEAAAAAAAAACAG9AgAAAAAAAAAAA3oEEAAAAAAAAAAG5AgwAAAAAAAAAA3IAGAQAAAAAAAAC4AQ0CAAAAAAAAAHADGgQAAAAAAAAA4AY0CAAAAAAAAADADfxvlgCc7jFLAAAAAAAAuIHnLAE4lwYB7kqRHgAAAAAA4LM+Va/RmMBtaRDgV3zq/4EAAAAAAADwXfbUlTQV8BM0CPAt9nxRAwAAAAAAwBlmtSoNBHwFDQJczezLFQAAAAAAAK6mV+PSOMClaBDgUzQCAAAAAAAA8Os0DnApGgR4Fw0BAAAAAAAA8K+2dqZhgLfQIMCraAgAAAAAAACAHA0DvIUGAc5yx4aAO/7MAAAAAAAAn3SXwrmGAV5CgwB7fXNx/Js/OwAAAAAAwJ2dWef5pqJ7/XN/0+fmYjQIsOrML92zXfmzAQAAAAAAcC3Z2tLVCvKaBdhNgwAZ2S/HV7vK5wAAAAAAAOA+ZjWqTxbpt8/2yc/AF9EgwMjsy+6VPvnuV/nFnwkAAAAAAOCIXyhsRzWgd/9c/qoAKY/n0/998IdPFLE/8c7ap98PAAAAAADA6326MPru97/7fXwBDQJs3lkkf/W7Xn0/AAAAAAAAv+/VhdRX319757u4MA0CvKOYfvY7zr7vXb71cwMAAAAAALzKtxYrX/G5X3Fn6x3v4MI0CNzXK4vVZ9595l0973gHAAAAAAAAn/WOwuiZ7zjzrtYr7+bCNAjcz6uK4Wfce8YdmzPvAgAAAAAA4F7OLKKecdcZd0RedS8XpUHgPl5VMD9y76fO7vWJdwIAAAAAAND3iWLn0XceOX/kbM8r7uSiNAjcw9mF7b33vftc5My7AAAAAAAA+G5nFkv33vXucz1n38cFaRD4bWcXw/fct3pmNX+z99yqd70HAAAAAACAuXcUO4+8Y/Xsan4p+86MnH0fF6JB4DedWcTec9fKmZXcUtbzI2fcAQAAAAAAwHc7Wijdc37lzEpuKev5I2fexYVoEPg9ZxW/V+9Zyc/mZvNqe86MnH0fAAAAAAAAr3Nm8XPPXStnXpVbynp+z1n3cBEaBH7LGcXs1Tsy+ZmcUvJ5pazlbvacyXrl3QAAAAAAAHf3yqLmnrtXzmRzM3mZnNpqfuSMO7gIDQK/4Yzi9ModmdyzckrJ5WVyeo6cBQAAAAAA4DvsLYxmz52VN9vfnJ03csYdXIAGge93RnE7e0cmb5ZzdL+UXE4p+byRM+4AAAAAAADgPc4ofmbvyOTNco7ul5LLKSWfN3LGHXyQBoHvdrR4nT0/yzuyf+RsZr+1mp/1qnsBAAAAAAB4XWF65d5M7ihndv7V+5tsXs/R83yQBoHvdLQYnT0/y9tb+H/F3iaTU1vNP+Kd7wIAAAAAAPgW7yxYrr5rln9k/xV7mf1ScjkjR8/zIRoEvs/RInPm/CxnTxF/NX5kL7PfWs0/26ffDwAAAAAA8CpXKEiufIZM7p4C/rvOZPdLyeWMHD3Pm2kQ+C5HisiZs7Oc1YL9alPAavzIXmQ1/0yffDcAAAAAAMArfbogufL+We6ZhfwovpJ7dG+TyRk5ep430iDwPY4UkDNn9xTaV+Kvyh3FZ3uR1fyzfOq9AAAAAAAAr/bJguTKu2e5q8X7ow0A2djRvU0mp+fIWd5Ig8B3OFI8np3dU1xfiWdimZy98dleayX3TJ96LwAAAAAAwKt9siCZffcs7xWF/bNjR/cy+yNHzvImGgSub2/hOHNutdieLeRnYntz9sRne7Vs3lHveg8AAAAAAMAVvatImX3PnqJ6tnCfiZ2Vk9mb/U5m+yNHzvIGGgSubW8ReXZutZC+N7a6zub04qs/VyuTs+Ls+wAAAAAAAH7dK4qXmTtXC+17Y3tyZutebBSf7WX2I3vO8EYaBK5tT4F5duZowT0TW1nvuW8lltnL7PfsPQcAAAAAAMC6vcXN2bnVQnom9u51L7Ynnt2P7DnDm2gQuK49hefZmbObA1YK/yu5UWy27sVG8ex+bSX3DO9+HwAAAAAAwBHvLj6uvG+Wu1JEnxXrz1yv5K7GRvHsfmTPGd5Ag8A17SkK7/lvz2eL7LPifK/Yv/fcnvVKLLOX2Z85eh4AAAAAAOBujhYvM+dHOdnC+qxIv7fgv3cvWq/ERvHZXs+eM7yYBoHr2VNU3lMEzxTTV9aZ+Vl7mXUvNorP9iKr+QAAAAAAAOy3Utyc5a4UymfF+GxhP5s32lt5d7TuxUbx2V7PnjO8kAaB61ktOO8pdq8W17OF/Mw8m5c9k1nP4rO9TSZn1SvuBAAAAAAAuKJXFSYz964WvjOxbNF+dZ7Ny56P1r3YKD7bi6zm82IaBK5ltVi8WvDOxLKF+U/NV/ZGsVF8thdZzQcAAAAAACBvtai5WuTOxFbW75qvfKZovRLL7EVW83khDQLXsVpgXi1uZ2LZwvujGVfns/0982h9NNbK5IwcPQ8AAAAAAPCLjhYsZ+d7+9nCeK9IP9qbzWf7mflsP7teiWX2Iqv5vIgGgWtYLRwfbQ5YWc/ms/1Z7uzMnnlm3YuN4q1s3hHveAcAAAAAAMBZ3lF8zLzjzKaAdn3GPBtbyc1+5mi9EsvstVZyeSENAtewUgR+ZXNAZu9TsT3zaL0Sy+zVsnkAAAAAAADkZQuaq8XsWdE8W3CfFeuz+2ecHc33rHuxUbxnNZ8X0CDweatF5V5+puidaQDIzFdjmZw9sew8s+7FVvZnjp4HAAAAAAD4RUcLlkcbA6JYpuCeLdSvxjI5K7FeTnbdi43iPav5nEyDwOetFI0/1RyQKf6P9lZyV/ey88x6Fp/t7XH2fQAAAAAAAFd2ZnFydle20J0tns8K8SsF/szeyplZbDTPrHuxUTyykssLaBD4rJXi8Eoxe1YInxXUV2N7x0zO6mcZzTPrWXy2t+rMuwAAAAAAAK7urOLk7J5sgTtTQJ/Nzy72PxfyVvZG8z3r7F5rJZeTaRD4nJXC8EqxemWdLbSv7D0me/WYyZmNs1g7z6xn8dneirPuAQAAAAAA+AZnFCdnd0T7s9je+d5xljM7n7lnFmvne9azeGQll5NpEPiclcJwtoC9sl4ttO8ZMzlnjLNYO8+se7HM3oqz7gEAAAAAAPgGZxQnR3dEe7PY3vkrx0zOaMzutfPZXi82ikdWcjmRBoHPWCkK93JnBe1RATxTYM/s1WM2ticnM85i7Xy214tl9lacdQ8AAAAAAMA3OKM4ObojU9DOFMdnxfQ9YyZnlJs5t1nJGc2jdS82ikdWcjmJBoHPWCkK93JHxe52nS2inzH25qO8TP7KeHQ+imX2Zo6cBQAAAAAA+BVHCpUrBepRwXs2Xym6j8ZsLNqb7ddjFMvkjuaZ9SweWcnlJBoE3m+lONzLbeOjdTQfxVbGWezo/hnjnvkoNor3rOYDAAAAAADc0WrhMlukHq1n8zPGWWxlP/O+lTE7z6xn8chKLif43yyBj9lbnN5TAF8ZZ7Ej89VYZtwzj9azeC2TAwAAAAAAwFimeBzlzGIr85XxWf6tE9VjmcSOiN63OpbkPDLb54I0CLzXKwrHmTujQvie8eg8k5fdz+xtVufRuhfL7I3sPQcAAAAAAPBt9haTZ+ei/TY2awTozWcNAO3YK75HsU27ntnui2J7xtLMezI5peTzSlnL5QQaBK6pVzSeFbGjgvcolhl7sV7OLC97bjZvx97eLNbOM+vsXi2bBwAAAAAAcEfZIvEor92bFf8z83rsxR7N2JuXZh6tV233R7GVsbbyeXuf/+jPxYtoEHifowXi2flRwbuOrYzZ+WxvNb+3F81Hsc0oNppH61l8tgcAAAAAAMDcrLjc22/jUdG/N+/F2kJ6JhYV2Ot5Zl3b7h6pc+rPsjqWwfwVXn0/FQ0C1zP7h73J5EWF8SgejaP5nnUmZ7RemddjFIv22nm07sVG8Z7VfAAAAAAAgF+xWgwe5Ud7baxeP5sxE2v321hdXG/no4J7/b56P1q3tvdk5tHYM9uPcnpnMnfxZhoE3uNoMXhWuB4Vw7N59TiaR+t3xMrCPBqze+18NdbK5AAAAAAAAPCvWUG5t9/GR+uo4D/am8W259Hs1es2VmtjUc7M9v7evB5LEJt9rj2fiQvSIHAte4rJ2cJ2tmA+mkfrd8TbWJnMM+Ms1lv3YqN4z2o+AAAAAADAt9tTZO6dieJtrF63hf4oFo29WF1Yj/ba4vosVscztvdH62jevns2luQ8Ws/irWweB2kQuL5Mwbo1K45HBfHHZB6ts3tH9tv4aF0OjKP5amxlHwAAAAAAgP/MisTRfhsbrZ8HxnYerR/Nus5r91rb/ortndG6fW89b8fWns/CF9Ag8HrZAnE2rzYraEcyhfFHM4/W0ZPJWcmNctpYmcwz42ieWc/ikZVcAAAAAACAX7JaeO7lt/HROpqPxlmsfh7NugSxeq8WnV21fYZ6XarYM5jXY+nENlFeO4/Ws3grm8cBGgSubU9heqUY3sai9SNYj56V3NU7oniZzFfG0Txa92KZvaNeeTcAAAAAAMDMKwu5o7ujvTZWr6P5yjiaj2JtEX30ZGz39NTvq2OPar7tP8uf97WxKIcfoUHgtbJF3GxeLVOszhTC64J6ve7FznxW747yy8I8M27q9WhvFGtlcgAAAAAAAO5mVoTu7bfxej2bj8bsvH4enfjsZ8vY7s7YPku9LlWsLfw/glgkOtPOozUXo0HgujJF6V58FOsVvh/VE8U+/ZRkvATzUaweR/PMehYf2XMGAAAAAADgW6wWjXv5UbyN1etoHo2zWG9dP4/B3tFnxZZf15/qWDsfxeq9I7L3ZPPYSYPAd4qKySvF76iY3ua9+vknkbM9ZXG/BPOVcTSP1r1YZg8AAAAAAIB/jQrD0V4bq9fRPDOO5tG6fUr5tzbUxv+vvF/9O9jqVc9g3n7uOlaLctt5tOZCNAi8TrYonMnr5czOZgrf0frsZ6UZYM9TButonhnbeWbdi0WyeQAAAAAAAL8oU0Du5bTx0fq5MI7m0Xr0tP7p5B1pHIje06tBbbmPxHyzxaK9Pc66hwM0CFzTqHg8KkqPityzwnf79ES5vWfWGDDbX3nKYB3NR+NonlnP4hlHzgIAAAAAAHza3kLw6Fy7N1pH89E4mkfrvU/bENA2DmQbBp4lric9y5/anG3/MZnXsdrsXJS36shZJjQIfNaRIvDsbFTgjgrmo+J29Iz26qdX/F+NrzxlsI7mo7Gd71m3ZvsAAAAAAAB3NCoGR3ttbLR+DsZZ7DmJZZ+66F83BETNANv+qFHgWfJ1p/p3UZ/Z4o9gPovxxTQIXM+o6Bz9Q88WuGeF75VndiYq9mdjo3jmKYN1KfPYJjNfjfWs5AIAAAAAAHyrlQJzlDuLzeb12Itl1pkn0xQwagbo1Y+eg72Z+ney3bHFHs1+L9bGe/OeTA4vpEHgNfb+ozxLprj9OPj07miL+5nGgDMbBcokVnaMm3rd7vVimb1VZ94FAAAAAACw15mF3tFd0V4da/efO8Zncp15/q/0/6cDoqaAXmylcaCU+Pe0ac9tuVu8Xrf3bLFob2Q1nzfQIPCdev/wewXsdr6nwNwW3dvCe/TMGgFm615s9pTBOpqPxtE8Ws/itUwOAAAAAADAr8kUjXs5bbxeR/PROJpH69nTNgFEsVmjQL2OaklRbPuso9pT+3vbcuv4o/x517OJ1Xrxs7z6/tvSIPA5mX/Qo8J0HcsUs6O7V57MmVEx/5/OfLY3u7f3lME6mkdjdj6KjeIZR84CAAAAAAC809GCbu98FK9js3lb7B/FeuvZ0/urAW2zwKxR4J/OfNPWjp5BLKP+PW3nt9ij2a9jo7123pPJ4UU0CPy+tqi98gUxK7qPnl7RPzPPrDNPGazLjrGdr8ZW9gEAAAAAAH7ZrEAc7bex3nplfCbXo2fWHNAr/td7vXpUW1Oq189gf/Z7rW1n6zOPal3P9zrjDk6kQeB8ry787iliR+vME+WvnG+fTHPAmX9NoAzW0Xw0tvPMOrs3svccAAAAAADAux0pBI/Otnu9dR1vY23RvzeP1qMn+isBpfzZANCbl/JfLaj3lwPq+bPKr+ebKDbS/h4fVaw37+XzJTQIXNeoMN0zK2av3NMrrEfr0TMq8mcaA97RJLAytvNoPYvXMjkAAAAAAAC/IFtM7uW18Xr93DE+k+voaRsBtlhvvc3bwn8d69WjMvWqZxPL/q5L+e/cduZR4vNbPNqvY73zq866h4oGgc+IisJHCsWzL4vaI/FEub2zUTzTFBA1AYwaA2br3lMG62gejb1YtO7FMnsAAAAAAAB3MyoAR3tt7NkZe3uj+ShWP3v/JwV6DQHbOGsW2MZn+XO/XtdF+qz6d/aYrPeI7jjjXnbQIPBdRgXsKG+br3wBPMqfZ3rrdm/vk20YiNa92PaURLwsjKN5tM7u9ew5AwAAAAAA8El7i76jc+1evY7mmXHUDBDF2sJ/G2//UkBvPhpL+a8+NGokqGtIz2pdz7f1ikf580y93uajHL6ABoFrGhWhe2bF6qhQHj1t/srZ9un91YDZmJ1H76qf0sktk/mmjUV7vfUsnt0HAAAAAAD4FZlCci+njdfrqAFgNs6aAUr5t46zFfdLiRsD6vjof1KgV3dqx96ZZ/k79zmY13lZK4X/aL+Ozc7zIRoEzrX6j+wMe4rWI3WxfFu38XZex854Zg0D0Tr7lMG6DMbRPLNuzfYBAAAAAAB+1axwHO23sXrdNgC0sXa/bQRomwPa/UxjwLbu/U8KZMdS/qxTbYX/Lbatn0Esmu+x3d9b88U0CLxfVBjOFItHheuRTF5bMK9jpRnbeXs2itfP7K8HzJoDjjYKlM66jrexTRSL1r1YZg8AAAAAAOAOZgXnlSaBXmPANrbzRzWP1r0n+ksCZ/zVgGjcPtcsd9QcUNekZr/vzfbuaN3uRTk9mZzI3nN0aBD4Pb1i9eiJcqN5HZvd18ZWC/ntuVljwOz+MomVhXE0H8UyewAAAAAAAHcxKvxGe3WsLYbXsWjc9tt5HXuUv+Nb4b+UvxsDttjevxowqknV89HPVf8O6p+1nm/rjPZM9J9D9Lvd4+h5dtAgcD2zwnOkzcueq9VfNNu6jWfGlWf21wNmf00gWq88pRmjWDS288y6NdsHAAAAAAD4ZXVxO7PXxupC/6Oa98a6oN3O6yfSawzY1tFfEMg0A0R722dr5+3Zeqx/nja2zVdt9/XWPXVe9gxvpEHgu80K1pkidJvX+5Lpxdonyp+dyT5nNQqUznplHM1HsZV9AAAAAACAX7TaHLDFo5y2UWA0bnl1M8CjifWeqDFgW2f+JwVGjQKZeebnq3/Odl6q9Ux9lh+jQeA7tF+CK4Xlx+Rpc9t5+yXUnh3trzyzvx7Qaw6IGgOiWEnEysLYzqP1LN7K5gEAAAAAAHyTttgc1UTaYnYv3jYH1PPZ2GsK2NTxrei/yTQGZP56QBTb3jublybWG0sw387WoiaA7Z5eLNrni2gQOE+muJvJGZmdn+33tF8q9Xw21k9JzI8+Z/wVgTJYl8Q4mkfr7B4AAAAAAMAvGtVHZsXrOj4qgD8mY6nmvUaBuvAd/c8KbPFeY0Adq8dMU0CvZlXPo8aB2c/azmvt77yUcXPAKN7L42I0CHxe9A9vRXt+9b46P5rPxjY2ezJ5o78e0Ob09jNP6awzYzuP1r3Yyj4AAAAAAMAviQrQ0X4d7xW9t71Hcuw1CszUDQCl/PfuWWPANkaF/ahe1cubzbNNAqVaZ9Tno3Uv1nP0PCfQIHBdj7Jf5mz9pbOto3m9jsZo3ttrn95eL77SCJD9nxlo4yUxjubRehaf2XsOAAAAAADgnTKF3qju0RahR7F2/1HFswXzXpF6e9r/eYFS/mwGGP0Vgai+NJq3DQNtA0BJzDM/86Zd92Tz3uFKn+XraRC4lkfJq3Ojc/UXTBuL4rN5G2vz2i+zdq/db5/RXvvM/nrArJGgfVcJ5plxNK/14q1sHgAAAAAAwBX1ah2z4u52LtMo0Ct877Hd0d6z/c8LtI0CUV1oawyoC/vbflvsj+a9dSnxfjTf0yRQmljt6O/27P+cOJEGgd9Xf5n09kfxdmxjUbzeG8UewVOCeW+MnllzQO/9JZhHY3YerbN7AAAAAAAAvySqi0RF4y1v9b/xvuX0xlL+vid7b29df9a2xhTF2nnUBFCve589mvd+ltHPv8Uie+7iS2gQ+D69f6h7jL7Uonj0pbfN2y+1aL93ps1Zedqz2btG50piHM1HsVF81Vn3AAAAAAAArDijOPwo+Xvq3N78FdpazLZ+VvN6nDULzJoARjmj+Z6GAW5Kg8D1tV8uPbP9mfr86J1tXnSutx/FRuvMGD2jvV5OCeajcTSP1tm9rDPuAAAAAAAA2ONRfr/QXDcBtOttrIvxbZ1p1Biw0iiwxWYNEr3/TEZ3HXXmXbyJBoHvdqRIvHq2LYa3695eHZvdEa0zT5TfuyeKl8m8HrPzaJ3dyzrjDgAAAAAAgFVt8XyPlTvq3N48yh/l1oX1WhTv3RONK40Bo0aBXl62ISCTmzU7H72Ti9IgQCl/fsH1vtDaeWv7guqts3nRejZG52fvr/ejdWYczWu9eHYfAAAAAADgSvbWNtrid2+/3ss0EkQNAaO8NlZr313HokaBUTH+sbjezPLaM9EdI6v5tSNnuQANAp81+zJblb0vmzcT3dPGti+sKK+Oj9azsc2v171ndK6N994XzaP1LD6y5wwAAAAAAMCnzP6b5pFeY0AUewTzSFS43+L1OjI7EzUHPDrzklhvoniUV2vvjT5bm8eNaRB4n28o9GYK221OdKYXy8RHeb0xc741OtfO6zE7H8UyewAAAAAAAN8oU/+ICuPtXi82mtdjCeZbbr2O7DmzaT/XaF2f6cUzsT3Ouocvo0Hgftov5VFRO/MF3rN9ka3EIyufYfS++on26/VI9Lt51c/Tc8YdAAAAAAAAR+0tMNe1jl6zQPvfot9i7XxW6J8V+Vc+y3Zfb2zPtj9DtjFg25v9ftufb+89I0fPt86+j0UaBH7PO4rH7Tv2vHN2ZlR0b8d2vq1774j2Vt/XM3rnyGwfAAAAAADgalbqG72i8HbHrDg/sxWeswXo6P7Vd7ay794rc//o95A5z4/7Z5bAT1n5km7tPbtybm9x/Wyz940aEyKznNk+AAAAAADAt5vVQ2b7pcQ1mkx9qc2ZvWuU3743uivzvtFnmH2+s7zrPVyIBoF7+URH0CfeCQAAAAAAAHu9o771jnfAXzQIkFV/SbVfWGd9gfXuOev+2ujO2ecY/S4is5zZPgAAAAAAwLeb1UNm+6XENZpe3WpvbSvaG713lt/LGVnNj2TuyOTwY/43S+DrPMt1/hzI6LPMPme0v8XaMcrfvtCiO3rx2fsyVt/b7mdkPwsAAAAAAMArrdQ3enp3rN69Jz96jlg9fzQ/Oj/KWX0fP0iDwPusFJlfKSqkrxTGM+dn8eiOOtabR2a57RfdrHCffV99rr1jy2tjdTzay/LlDQAAAAAAfLNRrWNW9M4UvJ/NuM1Xayztmfbe6D1tbr3u5WXOz6zmZ51979n3sUiDwGfNitHv1vs8K59z+xKLCuNtvBcbNQq0Y5RXyp93Rtq8et3OZ+9r79jO9mKbzBfg7OcAAAAAAAC4kkz9o5UtkNex58LYnmtjtWi/Xs9+vt65UWwld7bu2XuOH6NB4Lc8S66g3OaddS66Z/viyjQGbLHRvB1LMN/uG+k1FLR3R3rv3tYlEauNfveznwMAAAAAAOBbzOoe0X4bq9fP5LjNtyeKtXv1fr1u5/UYzaN1L7bFZ7He73H080MpRYMAf3uW/n9zPsrb5m3e3thsHn2udl6LGhba/ejLcdSQ0JNpFmj3evsZo8YCAAAAAACAV3/sQkcAABwySURBVNhb12iN7mn36nU0z4ztuczT5s/Olmpsz0Xr1Vhv3e61ZnetiM4euY830yDwPZ4lLnbvLRK3Z2d31fuj+bPEd8/y6nU0L4OxnZcybxio43Vhf9YI0Mudnaut5PaccQcAAAAAAMAeZ9UoevdE8V5daFZHqutS7br3niinnc/G9jNG62yst460n6W3vyJ7JpvHB2kQuL5nyRXye/GR2V3t2J7pzbf19kRNAFFONC9NrB1LM4/Wv2jPf94AAAAAAABHnVWDGd0T7dWxaD4a2/ksFsVXn9LM2zvbWG2W82zGdl7rxc/wyrt5EQ0CPEu/yN/bf3bmZbDO5ER3R80C9djOo/WZer+v6HfXs5I78sqfEwAAAAAA4FVmNY5R7Wc2r8fRPFqPnuie3ji7p85r17Ocdj6L1aL46DPygzQIfK9nmRene/+As00A7V8EaOPtPLOu76m/ZEbzbXyUv+PtPFq3ej9bPe+NI9G9pcTnos84ux8AAAAAAOAbzWo3myhvVAeK6km9sZ3XTy++9ymJeW/d5rfrdl6PrfaOdi9zLor1zkVWcnkDDQLX8izzon/W6Pz2D3Fvkfw5ma+ue/PSxP6vlPJPFd/U8W39aGKl/HdX7+fOin5X9V7pxNp4q86rrX4+AAAAAACAd+vVOWZ656J4HYvm0Tiat08p/9aZor3/68z3PmWw3kTrdj4b23m0jmRyeo6c5cU0CPymZ8kVldu8er3Ne2Mvf5vX+b11mcy3MWoMaJsCoi+arVGgfur8OlavRz97mcw3UayOb7L/OQEAAAAAAPyCWd0j2q9js3k0tvNoPXoyTQPRUzrzlbzeXkmM0bxez7S5K2cj0fnMnZkckjQInOdZ5sXeKCdzbpM5v3JfKf/9gxoV/aNxz7z+Umr3SjCPxtFfEXiUv/9qQGt7b9QYUK97Y5nMN1Gsjm/afQAAAAAAgDvp1UqieB2L5tE4mkfr+okaAEaxdq/XQDB6Zy+vVGM9742j+YrZudk+F6NB4Ds8S64JIIpH/yhnZ6N5NLbzkpj3Gga2cWsA6I11ftQUUP/VgDr/UT1trF2PfuYymG/r0sRG8SgHAAAAAADgl4zqI5teThuv19E8Gtt5tJ492eL/bK99yuK8jfXGaL6ZfZ6M6E6+gAaB7/YscVE/2m/jtbZ4HRXAR00CJYj15nX+VvSvY5mxbQzo/fWAullgs32eUWNAmYzR7ylab7ESxOu9TZQDAAAAAADwS2b1kGi/jdXrWV2pHtv5KLY9s78i0PvrAdn9lacsjNG8vqcn2u/dyRfSIPC7niX/30jf/iFHzQbbvB5LM0bNAr151BQw+6sB9ThqDKgbAkZPKf997qgxoP1526aATTtvvxCjWGYPAAAAAADg143qJCtF6mjeq1PVsWg9ezJ/RSDTEDBrFiideeZM7+yK1fxaffbIPbyIBoHreZa4UD/S5mXPtbZ/pG1B/DmJ1V8wUSz6Ulr96wH1/8TAqDGg/SsCpfz3udomgXr9bMbSGaPfUZ1Tr3tfepoDAAAAAAAAxvWSdm+0ntWZRrWr9illXsCP/oJAPZ+Ne54yGdtYO69jo3fUeaM1X0qDwPs9y/7ifa+QHeXV64xeg0H9vlL+/gxtTuYLqR5X/mrA7C8I1LGoIeDZxOp1acbo56x/R1FDQGv0n/Oe/xsAAAAAAAD4FaMaVrQ3Kli3NahtPqtbPSex+hn9tYDefua+1XP1U5oxmtfrOhZp93v50btnopzMOU6mQeBcz7Kv8Lv3XCl/nm3vWbm3/gcYNQS08zbW+yJ4ln7xv3emzSvBPGoUmD1lsK7n7e/t0YztPFr3Yiv7AAAAAAAAv2hWGM4Uk+t1VKiuY6N5tB49bUF/718TyDxlMka50f6KNr9er951hk+886dpEPgdz7K/OaC1/UNbaRTYM/YaB0oTezTzaJ19ntW8BPPROJpH616slckBAAAAAAD4dplib5STLVpn6lPtPFpnnkyjwEozwN6nNPNtXZvdEeWP1j2jz8BFaBC4pmf5r2hcz9v9aK/er9cr6ndv69l8NvaaAaLx0cS2849gXT/bXyVo4/VTJvNonMV66+zeyN5zAAAAAAAAn7Bal9qMzo0K1m1NKorVYzuP1tkn0yRQz7Nj5imdeW890+b1zj2bkS+jQeC7PMu8IaDN6Z0Zqf9B100A7d42HzUK1EX+Wc7oLwg8gnUd385sn2XWHBA1A+xpDIh+t7Pf92wfAAAAAADgDmZF5mh/VrdaGZ+d9eozawyo55kmgFFOScy39ar2XL3u3XnWu3gTDQKf8Sx/F4mj2Kr2jnq95x9Z2xxQr6OmgHoeNQb0/mpAuxc1A0TNAaO/JvAMYmUyH42jebSexWuZHAAAAAAAgG+XqVdlC9G94nVbv4rGXkH9GTxtvFe8z/w1gVlsz1Oaeb1eeeqztXbdc8YdvIEGgfM9yzkF3/qe6M4t1nvf7HxG/Y91e1e0N5vPmgUeg3m07sWi4n8vVsrf8Ta2ycxHsczeyN5zAAAAAAAA77S3EDw6F+3NalMr47OzHsWPNAn0zs8aBcrC3h71ud4dz2Z8tXe951Y0CHyfZ4kLxnW8N9/Wqx7l73O9L4l6PmoMmM0fwboXmzUD9BoBek0BK00C0XoWz+4DAAAAAAD8olm9alagjtbRfDT2CuvPROxZXtMkkM0pyVj22WTmtV6cC9MgcC3PcrxoXN/RzkvZd3/7j7ttGKjndaG/3us1AJz1VwOi4n8Ui+aZsZ1H615sFM84chYAAAAAAOBdjhSMV4rQbSyqW2XG0bwtoEfxZ8n9NYBs08DKUzqxTe9MpN7rzUdGZ6I7svfyAhoEPudZ5oXfOifK32LtODt75B/d9p7aaJ35ywDvag6o13W8jW0y82jdi7UyOQAAAAAAAL8mU6vKFJYzhe1nMPZi0boXq5/MXwNYXc9yZ58rMsqbzXsjX0aDwGs8y2uLv7P76/12XsrfZzP/gNs7am2s/SsC0Xor+o/W25NpDmiL/rN1SYyjebTuxTJ7K866BwAAAAAAYK9MfSlrdFemNrWnuN2LReterH6yTQJRbO9fEXiWf81y2vxaHevNP+HT7/9ZGgSu51n6BeBob4uN9qJ5LVNwHv0jbBsASvk7v20CiGJRE8De5oA2Fs0zYzvPrGfxyEouAAAAAADAt1kp+PZy2/ho/VwY23m07sXqZ1TozzQK9OKzBoIV0bnZvB1rvbPRmgvQIPBZzzIvDPdyZvF6vzff1mdo74kaAup4vddrDOjttU+ZxKJ5ZhzNo3UvtrIPAAAAAABwJ7Na1awo3a4zBe5oHM3rpxevn1lBP9sY8Kpnk5lHZvsjR85yAg0C3+dZ/i4yb7HRXjQvTf6Rf5DRXxHY4o/JXrSfaQxoi/9RLJr3Yu1+G+ute7FRPOPIWQAAAAAAgE85UnPqnY3ibSwqcvdi7X4ba+dtgT2K957Vvyywsp99avV6Nm/HWhTL7PFBGgRe51lyBd4or4317prF6/3RfBN9jhW9JoFtry7i720IqJ+SiJXyd7yN1WN2vhqLZPMAAAAAAAB+SbYGlS1Kz4rc9Twas/NRbOXJFv2zedHTavfaeZ030tufnSsll1NKPo8dNAh8p2f5u7i8xdqxza/3SxNvjfZ6Rn8xIMo78pSFdVkY2/medWu2DwAAAAAAcGezelS7v7JuC+HR2Itl1mc/ZzQGzPba+ShW77U5fBkNAtf1LH8Wldv1LB7tb/M2VoJ1bbTXEzUAzJoGattnHD1lsI7mmXE0z6xn8ZE9ZwAAAAAAAK5upca06Z1p46N1pugdje18ttd7RnlHmgB67yqJvdG8jkV6+218dg8fpEHgtZ4lV/TN5tWiM1usHaO99o7tH2q7ro32Mlb/akAp/33G3v6eeT3OYtl1L9bK5AAAAAAAANxFpu4U5cyK0qMCeGbMzqNntn/ms8nsRfM6ZzTWothM9kw2j500CFzbs/xZUG7Xs3i7X+fVsdLMt/WW12pzj9g+x+jp5ZTJfBSLxnaeWfdio/hZXn0/AAAAAABA5Kw6UWR0d6ZY3Vtni+GzWDuvn178aO7qHZto3c5nsXZvFu/lcREaBF7vWXKF3GxeLTqzxXpjL6c0+5t6f6/tPb0nkxvFy2S+Z9ysrmfxyEouAAAAAADAr1ipPe0tTGcL45lxNB/FMnt7c6O8TS+vlL/z2lgtivdyR7JnsnkcoEHg+p7lz0Jyux7Ft1i918bavVLFN+26F2ttd/cK4fV+/fT22lgJ5qNYNGbnq7GVfQAAAAAAAHK1p9XYrCDexupxFuutZ/Eje9nPsInmo9gop9XGe3lciAaB7/csfxfV61iUG41lMI/WM7PPUBfxo3j7M7XF/3ZdDoyjebTuxUbxntV8AAAAAACAb7ZSbyolX5yOYtlC+crYzjPrPfFebuZ9ZTKvx16s3evtz+w5wwtpEHiPZ8kVgnt5bTxz35aTHdszpZln1pvo822x6Oeo423s0cTae9r5ypidr8ZamRwAAAAAAIC7yxSTZ0XsKDYrhrex0TiaR+u9Ob3YyvujeTS2evFam5M5M3L0PEkaBH7Ds/xdYI/2R2OZxLJG7+/FtvmjEysL88zYm7efsVfYX433rOYDAAAAAAD8gpXaUynrhew6PpuPYtGYnZ+xzuSUyXzTxmbjaJ615wwv9ng+/efyRtmCcLYAPVqPiuLRmN1r5yt7s3V2r5R5LBp7897+KDaKz/YAAAAAAAAYGxUxe3ttvLeeFcFH46gQH+2v7K2uZ/NRLBpnsex6Fm9l8ziBvyBwTc+SKzBn8qKcLVbvtbF6LM08q333aB3NH515GcRG4575KJbZq2XzAAAAAAAA7iRbgxrlzYrWvYL3qDgejdm97Hy2zp4rnXG014pirUxOKfk83kyDwHs9y7Ei8ex8vR/Ne+fb/WisRbGZ9t3Zz9qb12eyY3YerXuxlf2evecAAAAAAAC+yWp9aTM7Nyt2t/u9vbZ4nhlnscx+5mxmPorVYy3a680js/2Zo+dZpEHgup5lXMzPrKM7tthobM32V/U+Y/tZerG942ieWc/itUwOAAAAAAAAsUxNqpfTxkfraH7G2JvP9lfn7Tj7bNm9dp5Zz+JcwOP59J/PB2SLxysF6kwRPJqPiujRmN1b2Z/lrozZvXYerXuxUbxnNR8AAAAAAOBOVouWK8XpUWF7tXCeGffEju5nxpVYL6e3n4m3snmcSIPAZ6wUi7MF6tF6Ns8U10fjO2KjcU+snUfrXiyzN3PkLAAAAAAAwLc7UqQcnc0UsnuF70zxPLM3K97vycvkj8ZZbDTPrGfxyEouJ9Eg8DkrBeJe7qzAnSmMZwrre8ZX7EXjLJadR+teLLO34qx7AAAAAAAAruyswuTonmhvVNxemWeK7tli/mhvJWdl3DPPrGfxyEouJ9Ig8DkrReFebqagnSmOj4rtmYL8kQL/kbOz2GieWfdimb0VZ90DAAAAAABwZWcVJkf3RHuzAnemUJ4pukfjrGifGWc5o73ZzzOaR+tebBSPrORyIg0Cn7VSGO7lZoramYL5qOie2Xv3OIuN5pl1L7ayn3XWPQAAAAAAAFd2VmFydE+2eD1az+Z7CvSvHrN72Xm07sVG8chKLifTIPBZq4XhXn6muJ0pnGeL7yt72TGTk/18o3lm3Yut7K848y4AAAAAAICrOrMwOborW8QerWfzTGH+SO5s3BPLzqN1LzaK96zmcyINAp+3Uhwe5a4WvTMF9GxBfk+Rf+XMLJadZ9a92Mr+qrPvAwAAAAAAuKKzC5Oj+7LF7NF6ZZ4p1mf2Vs7siUXr2e+kF8vstVZyeQENAtewUiDu5WYL3dniebY4nyn0r+7tiUXrWTPA7PcTme3PHD0PAAAAAADwS44WK2fnM8XuvcXz1eL8KJbJ2RNr5yt7o1hmr7WSy4toELiG1aLxmU0C7Xplvmf/jLOjeWa9EhvFIyu5AAAAAAAAjGWLmatF7EwsW1g/UrQ/42wv1svJrvfGe1bzeQENAtexWlheKWZnYtmC+0qx/mixfyV3z7oXG8Vb2bwj3vEOAAAAAACAo95ReMy+Y6WoPSuUZ4rus2J+b56NHcnds94b71nN50U0CFzHahF4lJ8teq+sz5jP9o/Oo/XR2Mp+xhl3AAAAAAAA/IqjxcrM+UxTQDaWKcivzGf7mfms2L+63hvvWc3nhTQIXMtq8fgVTQJt7NVNA3vmK3uj2Cg+24us5gMAAAAAADC3WtAc5a8UvbPNAaO9T80z615sFJ/tRVbzeSENAtezWmTeU+DOFNBX1kfm2byVzxOtZ/HZ3iaTs8er7gUAAAAAALiCVxUlM/fuKXbPiutHGwSyeZn5nvVKbGW/tZrPi2kQuKbVYvEsP9MQkI1li/Z78kZ7mQaAbGwUn+1FVvMBAAAAAABYt1rYPKMxIIrNcrKF/Oxe9ky0Phpb2W+t5vMGGgSuaU/BeXZmpVC+WozPFvlX9tr17DP0ckbx2V5mP+OMOwAAAAAAAH7d0cJl5vwZTQOz4vosP5ubzTuSM4tn91ur+byJBoHr2lNUnp1ZKaDvic0K9ntzo/VKbBTP7tdWcs/w7vcBAAAAAADs8e7C48r7ZrkrhfNMbGW9d28lZ088ux/Zc4Y30CBwbXsKw7Mzq/9t+r2xTzUDrP58K/s9e88BAAAAAACQt7ewOTs32s8U5LOxlfUs92hsFM/u9+w9xxtoELi+vcXn2bnV/6Z9thg/K/avrldio/hsb5PJWfWKOwEAAAAAAH7NKwqXmTvPaBDoxWeF/tX1SmxPPLvfs/ccb6JB4DvsLTDPzu0ppmeL9ZnYbL0SG8Wz+5ts3lHveg8AAAAAAMBVvLM4mX3XaoPAanxW9M+cWYmN4rO9zH7P3nO8kQaB77G3mJw59+lGgaOxUTy7X1vJPdsn3w0AAAAAAHC2TxYjV969p6C+En9HbBSf7W0yOZG953gzDQLf5UjxeHZ27/5K/GjuyvmV/dZq/pk++W4AAAAAAICzfbIYufruvcX1bAF/pai/kjuKz/Y2mZyeI2d5Mw0C3+dIATlzdpazWqT/VDy731rNP9un3w8AAAAAAHCmTxcjV9+/t9C+Wrh/dTy7X0oup+fIWT5Ag8B3OlJEzp6d5e0p2K+e2fsZsvut1fxXuMJnAAAAAAAAOMsVipGrn2GWv6dRYLS3Gp/tZfY32bzIkbN8iAaB73W0kJw9P8vb0xAw2jvyvk0mp7aaf8Q73wUAAAAAAHB17yxWrr4rk7+3iP+Kvcz+JpvXc/Q8H6JB4LudUWzO3jHLO7J/5Gxmv7Wan/WqewEAAAAAAO7qlcXMlbszubOcVxb+Z/ubbN7IGXfwIRoEfsPRwvTK+UzuLOfofim5nFLyeSNn3AEAAAAAAMBrnVH4zN6RyZvlHN0vJZezWcmNHD3PBWgQ+B1nFLFX7sjknpVTSi4vk9Nz5CwAAAAAAADXtrcomj13Zt5ZOZuV3J4z7uACNAj8lrOK3Cv3ZHPPzitlLXez50zWK+8GAAAAAAC4o1cXM/fcv3Imm3t2XilruSNn3cMFaBD4TWcVqlfvyeZn80pZy93sOTNy9n0AAAAAAACc78zC5967sueyeaWs5Zaynt9z1j1ciAaB33VmUXvPXStnVnJLWc+PnHEHAAAAAAAA3+lokXTP+ZUzK7mbPWd6zryLC9Eg8PvOLoTvuW/1zGr+Zu+5Ve96DwAAAAAAAH3vKHQeecfq2dX8UvadGTn7Pi5Gg8B9nF3U3nvfu89FzrwLAAAAAACA73RmoXTvXe8+13P2fVyUBoF7eVVhfO+9e89tjp7f61PvBQAAAAAA4D+fKHQefeeR80fOjrzqXi5Ig8A9varAfca9Z9yxOfMuAAAAAAAA7uHMAuoZd51xR+RV93JhGgTu7ZUF9DPvPvOunne8AwAAAAAAgM94R1H0zHeceVfrlXdzcRoEKOU9xfGz33H2fe/0zZ8dAAAAAADgLN9aqHzF537Fna13vIOL0yBA7Z2F61e/69X3AwAAAAAA8LteXUR99f21d76Li9MgQOQTxfVPvLP26fcDAAAAAADwOp8uin7i/Z94JxenQYCZTxbOP/nuV/rVnwsAAAAAAGDFrxYqP/lzffLdfAENAmRdpah9lc8BAAAAAAAAVym2XuVzcHH/myXA/1d/qXyySD/7cvvkZwMAAAAAAOC3zGpTn3Tlz8ZFaRBgj+3L5orF+OwX4RU/OwAAAAAAAO+RrSld0Td/dj5MgwBHtF8+31R0P/OL85t+bgAAAAAAgG91Zn3nm9z15+YFNAhwpm9uGDjClzIAAAAAAABnUXviZTQI8Ep3bRgAAAAAAACALA0BvI0GAd5JwwAAAAAAAAB3pyGAj9EgwCf1vvw0DgAAAAAAAPDtNAJwORoEuCKNAwAAAAAAAHwLjQB8DQ0CfJPZl6sGAgAAAAAAAM42q1HB19AgwC/Z8+WsqQAAAAAAAOA+9tST4GdoEODuPvn/BDQnAAAAAAAAd/TJ+gzcmgYB+Bz/zw8AAAAAAAB4m39mCQAAAAAAAADA99MgAAAAAAAAAAA3oEEAAAAAAAAAAG5AgwAAAAAAAAAA3IAGAQAAAAAAAAC4AQ0CAAAAAAAAAHADGgQAAAAAAAAA4AY0CAAAAAAAAADADWgQAAAAAAAAAIAb0CAAAAAAAAAAADegQQAAAAAAAAAAbkCDAAAAAAAAAADcgAYBAAAAAAAAALgBDQIAAAAAAAAAcAMaBAAAAAAAAADgBjQIAAAAAAAAAMANaBAAAAAAAAAAgBvQIAAAAAAAAAAAN6BBAAAAAAAAAABuQIMAAAAAAAAAANyABgEAAAAAAAAAuAENAgAAAAAAAABwAxoEAAAAAAAAAOAGNAgAAAAAAAAAwA1oEAAAAAAAAACAG9AgAAAAAAAAAAA3oEEAAAAAAAAAAG5AgwAAAAAAAAAA3IAGAQAAAAAAAAC4AQ0CAAAAAAAAAHADGgQAAAAAAAAA4AY0CAAAAAAAAADADWgQAAAAAAAAAIAb0CAAAAAAAAAAADegQQAAAAAAAAAAbkCDAAAAAAAAAADcgAYBAAAAAAAAALgBDQIAAAAAAAAAcAMaBAAAAAAAAADgBjQIAAAAAAAAAMANaBAAAAAAAAAAgBvQIAAAAAAAAAAAN6BBAAAAAAAAAABuQIMAAAAAAAAAANyABgEAAAAAAAAAuAENAgAAAAAAAABwAxoEAAAAAAAAAOAGNAgAAAAAAAAAwA1oEAAAAAAAAACAG9AgAAAAAAAAAAA3oEEAAAAAAAAAAG5AgwAAAAAAAAAA3IAGAQAAAAAAAAC4AQ0CAAAAAAAAAHADGgQAAAAAAAAA4AY0CAAAAAAAAADADWgQAAAAAAAAAIAb0CAAAAAAAAAAADegQQAAAAAAAAAAbkCDAAAAAAAAAADcgAYBAAAAAAAAALgBDQIAAAAAAAAAcAMaBAAAAAAAAADgBjQIAAAAAAAAAMANaBAAAAAAAAAAgBvQIAAAAAAAAAAAN6BBAAAAAAAAAABuQIMAAAAAAAAAANyABgEAAAAAAAAAuAENAgAAAAAAAABwAxoEAAAAAAAAAOAGNAgAAAAAAAAAwA1oEAAAAAAAAACAG9Ag8P/agwMCAAAAACH/XzckAAAAAAAAAMBAeQqFkwLj4xcAAAAASUVORK5CYII="
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    y: 558.72,
    width: 610.78,
    height: 72.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 312.95,
    cy: 301.95,
    rx: 133.61,
    ry: 100.71
  }), /*#__PURE__*/React.createElement("use", {
    id: "image",
    className: "cls-4",
    transform: "translate(39.73 315.42) scale(0.29)",
    xlinkHref: "#image-2"
  }), /*#__PURE__*/React.createElement("use", {
    id: "image-3",
    "data-name": "image",
    className: "cls-4",
    transform: "translate(39.73 315.42) scale(0.29)",
    xlinkHref: "#image-2"
  }), /*#__PURE__*/React.createElement("use", {
    id: "image-4",
    "data-name": "image",
    className: "cls-4",
    transform: "translate(39.73 315.42) scale(0.29)",
    xlinkHref: "#image-2"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 6.94,
    y: 359.29,
    width: 581.55,
    height: 12.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 6.94,
    y: 359.29,
    width: 488.8,
    height: 12.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 171.81,
    y: 199.49,
    width: 240.21,
    height: 110.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 175.31,
    y: 203.19,
    width: 233.21,
    height: 103.38
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M408.51,272.64v33.94H175.31V267.49a129.21,129.21,0,0,1,32-2.2c9.2.52,19.19,1.85,27-3.12,5.56-3.55,10.06-10.25,16.64-9.77,2.65.19,5,1.6,7.56,2.38,8.82,2.73,18-2.15,25.85-7S301,237.62,310,239.58c13.79,3,20.29,21.31,34.21,23.75,5,.87,10-.5,15-.9,8.4-.69,16.76,1.34,24.95,3.37S400.56,269.87,408.51,272.64Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 291.09,
    y: 310.26,
    width: 14.81,
    height: 48.75
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "254.89 359.02 298.49 359.02 298.49 350.53 254.89 354.78 254.89 359.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "342.1 359.02 298.49 359.02 298.49 350.53 342.1 354.78 342.1 359.02"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 412.02,
    y: 199.49,
    width: 6.36,
    height: 110.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M281.07,190.11h37.2a2,2,0,0,1,2,2h0v7.21H279.11V192.1A2,2,0,0,1,281.07,190.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M282.47,194.68a2.12,2.12,0,1,1,2.13,2.1h0A2.1,2.1,0,0,1,282.47,194.68Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "301.98 254.32 299.04 254.32 299.04 251.38 297.91 251.38 297.91 254.32 294.98 254.32 294.98 255.44 297.91 255.44 297.91 258.37 299.04 258.37 299.04 255.44 301.98 255.44 301.98 254.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M298.5,215a39.85,39.85,0,1,0,39.84,39.86h0A39.86,39.86,0,0,0,298.5,215Zm0,72.68a32.84,32.84,0,1,1,32.84-32.83,32.83,32.83,0,0,1-32.84,32.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M298.5,221.47a33.41,33.41,0,1,0,33.41,33.41h0A33.41,33.41,0,0,0,298.5,221.47Zm0,60.94A27.54,27.54,0,1,1,326,254.88h0A27.54,27.54,0,0,1,298.5,282.41Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 270.69,
    y: 298.49,
    width: 49.61,
    height: 3.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 384.51,
    cy: 286.57,
    r: 15.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M374,275.14a27,27,0,0,0,8.31,7.47,27.54,27.54,0,0,0,7.57,2.91c1.05.26,2,.47,2.63.7a2.43,2.43,0,0,1,1.22.7c.53.73,1.55,2.44,2.44,4s1.6,2.9,1.6,2.91l1.08-.59s-.73-1.37-1.61-2.92-1.9-3.31-2.45-4.14a3.57,3.57,0,0,0-1.83-1.15c-1.15-.38-2.64-.67-4.36-1.22A24.39,24.39,0,0,1,383,281.5a28,28,0,0,1-6-4.73q-.78-.82-1.47-1.71c-.17-.21-.3-.38-.37-.49l-.1-.12h0l-1,.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M386.93,283.57c-2.76.26-5.64.35-8.26.35s-5-.09-6.66-.18c-.84,0-1.52-.08-2-.12h-.72l-.1,1.22s4.18.35,9.47.35c2.64,0,5.56-.09,8.37-.35l-.11-1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M387,295.42a2.45,2.45,0,1,1-2.44-2.44A2.45,2.45,0,0,1,387,295.42Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 403.92,
    y: 195.66,
    width: 71.56,
    height: 159.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 475.48,
    y: 195.66,
    width: 71.56,
    height: 159.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 405.62,
    y: 354.74,
    width: 8.36,
    height: 4.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 464.56,
    y: 354.74,
    width: 8.36,
    height: 4.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 477.61,
    y: 354.74,
    width: 8.36,
    height: 4.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 536.55,
    y: 354.74,
    width: 8.36,
    height: 4.54
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 437.51,
    cy: 224.9,
    r: 23.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M437.43,204.64A20.34,20.34,0,1,0,457.78,225,20.34,20.34,0,0,0,437.43,204.64Zm0,37.86A17.52,17.52,0,1,1,455,225h0a17.52,17.52,0,0,1-17.52,17.5Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-24",
    cx: 437.49,
    cy: 272.25,
    r: 23.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M437.43,251.91a20.34,20.34,0,1,0,20.35,20.34A20.35,20.35,0,0,0,437.43,251.91Zm0,37.87A17.52,17.52,0,1,1,455,272.26h0a17.53,17.53,0,0,1-17.52,17.51Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-25",
    cx: 437.43,
    cy: 319.46,
    r: 23.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M437.43,299.18a20.34,20.34,0,1,0,20.35,20.34A20.35,20.35,0,0,0,437.43,299.18Zm0,37.87A17.52,17.52,0,1,1,455,319.54h0A17.52,17.52,0,0,1,437.43,337Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M491.09,210.9h37.7a5.34,5.34,0,0,1,5.34,5.34v37.7a5.34,5.34,0,0,1-5.34,5.34h-37.7a5.36,5.36,0,0,1-5.34-5.34V216.25A5.35,5.35,0,0,1,491.09,210.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M491.09,275.21h37.7a5.34,5.34,0,0,1,5.34,5.33v37.7a5.34,5.34,0,0,1-5.34,5.34h-37.7a5.36,5.36,0,0,1-5.34-5.34v-37.7A5.35,5.35,0,0,1,491.09,275.21Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 169.67,
    y: 350.58,
    width: 98.36,
    height: 8.07
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "169.68 351.21 208.36 344.99 299.61 344.99 268.05 350.59 169.68 351.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "268.05 359.02 299.61 353.14 299.61 344.99 268.05 350.59 268.05 359.02"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 535.61,
    y: 371.64,
    width: 14.76,
    height: 214.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 523.15,
    y: 371.64,
    width: 12.47,
    height: 214.29
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "535.61 559.56 497.49 568.47 483.87 568.47 522 559.56 535.61 559.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "588.5 568.47 588.5 585.93 497.49 585.93 497.49 568.47 535.61 559.56 550.37 559.56 588.5 568.47"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 483.87,
    y: 568.47,
    width: 13.62,
    height: 17.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 58.68,
    y: 371.64,
    width: 14.76,
    height: 214.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 46.21,
    y: 371.64,
    width: 12.47,
    height: 214.29
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "58.68 559.56 20.56 568.47 6.94 568.47 45.06 559.56 58.68 559.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "111.56 568.47 111.56 585.93 20.56 585.93 20.56 568.47 58.68 559.56 73.44 559.56 111.56 568.47"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 6.94,
    y: 568.47,
    width: 13.62,
    height: 17.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M175.31,238.14c3.27,2.15,18.82,11.71,19.54,22.46s8.82,12.65,15.5,18.32,12.52,27.59,12.52,27.59H175.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M291.09,359.29H333.6c-2-10.85-21.75-14.3-30.86-14.3S291.09,354,291.09,359.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M222.63,254.82a48.13,48.13,0,0,1-28-7.33,34.86,34.86,0,0,1-14.44-19.33c-6.5-21.22-.7-46.86,17.43-51a55.85,55.85,0,0,1,10.62-1.37h3c13.31.42,24.72,6.24,25.57,18.8.07,1.13.14,2.35.21,3.67C237.8,216.88,236,254.19,222.63,254.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M211.29,175.83h-3a55.85,55.85,0,0,0-10.62,1.37c-18.13,4.1-23.93,29.74-17.43,51a34.86,34.86,0,0,0,14.44,19.33c5,.87,11.15.56,19.54-6.4,2.45-2.12,8.7-20.13,8.7-20.13l3.36-21.65s6.51,1.48,10.82-1a6.89,6.89,0,0,0,3.35-4.58C242,187.41,238,176.56,211.29,175.83ZM236.78,194c0,.22.06.43.08.65C236.85,194.41,236.8,194.2,236.78,194Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M164.31,439.43h46.42L203.1,555.71h24.22s23.37-99.85,26.45-113.16c5.46-23.58-2.87-38.53-19-43.71s-112.9-14.26-112.9-14.26l1.1,28.93A25.28,25.28,0,0,0,146,437.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M223.18,555.71s24.69,16.73,30.79,18.55,13.25,2.44,13.44,3.94,1.22,7.73-8.92,7.73H209.27c-6.71,0-11.29-9.34-6.21-30.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M301.1,336.38s7.2-5.09,10.07-4.8,5.46,9.77,5.46,9.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M237.2,439.43h46.42L276,555.71h24.31s23.35-99.85,26.45-113.16c5.46-23.58-2.89-38.53-19-43.71s-112.88-14.26-112.88-14.26l1.1,28.93a25.27,25.27,0,0,0,22.85,24.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M237.2,439.43h46.42L276,555.71h24.31s23.35-99.85,26.45-113.16c5.46-23.58-2.89-38.53-19-43.71s-112.88-14.26-112.88-14.26l1.1,28.93a25.27,25.27,0,0,0,22.85,24.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M296.06,555.71s24.69,16.73,30.81,18.55,13.24,2.44,13.43,3.94,1.22,7.73-8.9,7.73H282.16c-6.71,0-11.29-9.34-6.21-30.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M227,258.45c-12.85-15.75-98.87-29.81-121.16.56,5.18,89.43,16.72,134.47,16.72,134.47,8.78,35.26,71.77,48.22,98.36,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M137.43,179.45l-4.6-12.65a29.13,29.13,0,0,0-27-19.16H94.32A24.43,24.43,0,0,0,70.09,166.8L67.3,179.45a31.33,31.33,0,0,1-12.6,19l-11.47,8A31.75,31.75,0,0,0,30,235l17.4,186.9a19.13,19.13,0,0,0,18.79,17.55h109a16.14,16.14,0,0,0,16.36-15.91c0-.55,0-1.09-.07-1.64L182.67,235a37.43,37.43,0,0,0-17.34-28.61l-12.62-8A38,38,0,0,1,137.43,179.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M123.63,180.14,119,167.5a29.14,29.14,0,0,0-26.95-19.17H87.27A24.44,24.44,0,0,0,63.06,167.5l-2.8,12.64a31.26,31.26,0,0,1-12.59,19l-11.48,8A31.78,31.78,0,0,0,22.9,235.74l17.4,186.9a19.13,19.13,0,0,0,18.79,17.57H161.36a16.12,16.12,0,0,0,16.35-15.88,15.44,15.44,0,0,0-.06-1.67l-8.71-186.9a37.37,37.37,0,0,0-17.36-28.63l-12.62-8A38,38,0,0,1,123.63,180.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M248.89,466.65l-197.07.11c-4.45,0-8-4-8-8.86v-9.49c0-4.89,3.6-8.87,8-8.87l134.75-.07h62.3c6.83,0,12.36,6.11,12.36,13.61h0C261.26,460.55,255.72,466.65,248.89,466.65Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 43.77,
    y: 439.49,
    width: 145.61,
    height: 27.23,
    rx: 6.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M178.25,469.38h33.07a6.53,6.53,0,0,0,6.53-6.53,5.16,5.16,0,0,0,0-.79l-.75-6.23a6.62,6.62,0,0,0-1.76-3.67l-13.78-14.43a6.58,6.58,0,0,0-4.73-2H178.53a6.52,6.52,0,0,0-6.53,6.45l-.3,20.64a6.55,6.55,0,0,0,6.53,6.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M178,379.49h11.48a5.46,5.46,0,0,1,5.45,5.09l3.08,45.2a5.46,5.46,0,0,1-5.06,5.82H181.11a5.45,5.45,0,0,1-5.44-5.08l-3.09-45.26a5.46,5.46,0,0,1,5.14-5.77Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 220.25,
    y: 379.49,
    width: 13.6,
    height: 89.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M204.59,367.8h65.23a4.65,4.65,0,0,1,4.65,4.65v5a2.06,2.06,0,0,1-2.06,2.06H204.59a4.66,4.66,0,0,1-4.66-4.65v-2.39A4.66,4.66,0,0,1,204.59,367.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 149.59,
    y: 466.76,
    width: 17.76,
    height: 80.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 144.44,
    y: 487.96,
    width: 28.07,
    height: 59.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M158.47,547.2h-14l-61.8,10.56a10.64,10.64,0,0,0-8.85,10.49v3.66h84.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M158.47,547.2h14l61.81,10.56a10.62,10.62,0,0,1,8.84,10.49v3.66H158.47Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-64",
    cx: 82.99,
    cy: 581.12,
    r: 9.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-65",
    cx: 137.38,
    cy: 581.12,
    r: 9.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-66",
    cx: 194.78,
    cy: 581.12,
    r: 9.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-67",
    cx: 161.82,
    cy: 581.12,
    r: 9.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-68",
    cx: 237.2,
    cy: 581.12,
    r: 9.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M325.3,350.14a50.15,50.15,0,0,0-8.67-8.8,28.84,28.84,0,0,0-17.82-4.89c-6,.58-17.83,9.78-17.83,9.78s-44.84-2.39-46-3c0,0,.66-7.55,1.13-18.14-9.67,4.47-19.38,7.77-30.54,7.21.78,7.85,1.52,15.39,2.13,21.5a15.53,15.53,0,0,0,15.46,14h8.55s34.52-5.27,51.77-7.66c4.66-.66,8.07-1.1,9.18-1.22,3.93-.23,6.59-4.34,9.57-6.4,3.81-2.64,7.67-2.36,11.9-.7a13.78,13.78,0,0,0,4.74,1.43,6.45,6.45,0,0,1,1.91.11,3.42,3.42,0,0,1,1.23.86,8.65,8.65,0,0,0,2.87,2.18C330.46,358.37,326.47,351.57,325.3,350.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M238.93,327.74c.52-26.66-.92-71.6-16.57-70.38C200.14,259.08,193.89,278,195,285.19c.56,3.81,4.09,28.09,7.33,50.17C215.72,335.94,227.32,332.46,238.93,327.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M238.93,327.74c.52-26.66-.92-71.6-16.57-70.38C200.14,259.08,193.89,278,195,285.19c.56,3.81,4.09,28.09,7.33,50.17C215.72,335.94,227.32,332.46,238.93,327.74Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-72",
    cx: 228.6,
    cy: 219.94,
    rx: 13.16,
    ry: 16.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M200.81,175.81h12.28c16.67,0,15.51,23.33,15.51,34.2h9.12s4-37.37-22.26-37.37H204.11a3.25,3.25,0,0,0-3.24,3.23Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-74",
    cx: 233.32,
    cy: 219.94,
    rx: 10.46,
    ry: 13.32
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-75",
    cx: 233.32,
    cy: 219.94,
    rx: 10.46,
    ry: 13.32
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-76",
    cx: 233.32,
    cy: 219.94,
    rx: 7.1,
    ry: 9.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M233.93,216.53l-.39.68-2.65,4.59H237Zm0,1.79,1.49,2.59h-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M381.24,359.29H364.4L363.06,358V317.72l1.34-1.35h16.84l1.34,1.35V358Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M368.62,316.37s-5.87-4.09-4.31-5.07,5.85,5.07,5.85,5.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 363.06,
    y: 320.98,
    width: 19.54,
    height: 13.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 363.06,
    y: 340.16,
    width: 19.54,
    height: 13.8
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-81"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-82"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M223.45,125.41h64.66V39.13H223.45Zm9.77-76.51h45.11v66.73H233.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M303.36,94.1v64.74h84V94.1Zm9.77,9.77h64.44v45.2H313.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M367.32,84V0H302.58V84Zm-9.77-74.2V74.2h-45.2V9.77Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamerGuy);
export default __webpack_public_path__ + "static/media/Gamer-Guy.27d98944b49f2d9297bd9ec443fd2901.svg";
export { ForwardRef as ReactComponent };